<template>
	<div>
		<el-container>
			<el-header style="height: 98px;" class="fixed-header">
				<Header></Header>
			</el-header>
			<el-container class="main-container">
				<Aside @addTab="addTab" :isCollapse="isCollapse"></Aside>
				<el-main style="padding: 0;margin: 0;display: flex;">
					<transition mode="out-in">
						<router-view
							style="box-sizing: border-box;padding: 30px 60px 0;background-color: #13161E;color: #fff;"></router-view>
					</transition>
					<!-- 弹窗路由 -->
					 <router-view name="modal" v-if="$route.name === 'register' || $route.name === 'login'" />
          			<!-- <router-view name="modal"></router-view> -->
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>
<script>
	import Aside from './components/aside'
	import Header from './components/header'
	export default {
		components: {
			Aside,
			Header
		},
		data() {
			return {
				isCollapse: false,
				text: '收起',
				editableTabsValue: 'homePage',
				editableTabs: [{
					title: '首页',
					url: 'homePage',
					content: '首页',
					name: 'homePage',
				}],
				tabIndex: 1
			}
		},
		methods: {
			handleChange() {
				this.isCollapse = !this.isCollapse
			},
			addTab(targetName) {
				let type = false; //判断数组中有没有当前路由
				this.editableTabs.forEach(item => {
					if (item.url == targetName.url) {
						type = true
					}
				})
				// 如果tabs数组中没有当前路由 可以添加
				if (!type) {
					let newTabName = ++this.tabIndex + '';
					this.editableTabs.push({
						title: targetName.title,
						url: targetName.url,
						name: targetName.url,
						content: targetName.title
					});
					this.editableTabsValue = newTabName;
				}

				this.editableTabsValue = targetName.url
			},
			// 切换tab
			upTab(targetName) {
				this.$router.push({
					name: targetName.paneName
				})
			},
			removeTab(targetName) {
				if (targetName !== 'homePage') {
					let tabs = this.editableTabs;
					let activeName = this.editableTabsValue;
					if (activeName === targetName) {
						tabs.forEach((tab, index) => {
							if (tab.name === targetName) {
								let nextTab = tabs[index + 1] || tabs[index - 1];
								if (nextTab) {
									activeName = nextTab.name;
									this.$router.push({
										name: nextTab.name
									})
								}
							}
						});
					}
					this.editableTabsValue = activeName;
					this.editableTabs = tabs.filter(tab => tab.name !== targetName);
				}
			}
		},
	}
</script>
<style>
	/* 用于固定头部 */
	.fixed-header {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
	}

	.bread-crumb {
		height: 98px;
		display: flex;
		align-items: center;
		box-shadow: 0px 3px 6px 1px #F9F9F9;
		padding: 0 15px;
		box-sizing: border-box;
		background-color:rgb(19, 22, 30);
	}

	.el-header {
		min-width: 1200px;
		background-color: #181D2B;
		color: #333;
		text-align: center;
		line-height: 98px;
	}

	.el-main {
		background-color: rgb(19, 22, 30);
		/* height: calc(100vh - 98px) !important; */
		height: 100vh;
		padding: 0;
		overflow-y: auto !important;
	}

	.main-container {
		margin-top: 98px;
		margin-left: 0px !important;
		height: calc(100vh - 98px);
		/* overflow-y: auto; */
	}
</style>
<style>
	/* 路由的简单过渡动画效果 */
	.v-enter {
		opacity: 0;
	}

	.v-enter-to {
		opacity: 1;
	}

	.v-enter-active {
		transition: 0.3s;
	}

	.v-leave {
		opacity: 1;
	}

	.v-leave-to {
		opacity: 0;
	}

	.v-leave-active {
		transition: 0.3s;
	}

	.top_icon {
		font-size: 26px;
		cursor: pointer;
		color: #3B3B3B;
	}

	.tabs_box {
		background-color: #fff;
		width: 99%;
		margin: 16px auto;
	}
</style>